import VueTypes from 'vue-types';

export default {
  props: {
    isActive: VueTypes.oneOfType([VueTypes.bool, VueTypes.object]).def(false),
  },
  computed: {
    activeMixinClasses() {
      return {
        'fly-active': this.isActive,
      };
    },
  },
};
